export enum DialogSize {
  SM = "modal-sm",
  LG = "modal-lg",
  XL = "modal-xl"
}
